import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { ArrowRightXs } from '@lichtblick/photon/icons/arrows/arrow-right-xs';
import { ChevronDownS } from '@lichtblick/photon/icons/arrows/chevron-down-s';
import { ChevronUpS } from '@lichtblick/photon/icons/arrows/chevron-up-s';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useScrollLock } from '../../hooks/use-scroll-lock';
import styles from './sticky-nav.module.scss';
export const StickyNav = ({ items, visible })=>{
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTouchDevice, setIsTouchDevice] = useState(false);
    useScrollLock(isExpanded);
    useEffect(()=>{
        setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
    }, []);
    const handleMouseEnter = ()=>{
        if (isTouchDevice) {
            return;
        }
        setIsExpanded(true);
    };
    const handleMouseLeave = ()=>{
        if (isTouchDevice) {
            return;
        }
        setIsExpanded(false);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                "aria-hidden": "true",
                className: classNames(styles.nav, visible && styles.visible),
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        className: styles.toggle,
                        onClick: ()=>{
                            setIsExpanded((prev)=>!prev);
                        },
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        type: "button",
                        tabIndex: -1,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                size: "m",
                                children: "Inhaltsangabe"
                            }),
                            isExpanded ? /*#__PURE__*/ _jsx(ChevronUpS, {}) : /*#__PURE__*/ _jsx(ChevronDownS, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: classNames(styles.flyout, isExpanded && styles.expanded),
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        children: items.map((item)=>/*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsxs("a", {
                                    href: item.linkUrl,
                                    onClick: ()=>setIsExpanded((prev)=>!prev),
                                    tabIndex: -1,
                                    children: [
                                        /*#__PURE__*/ _jsx(ArrowRightXs, {
                                            className: styles['flyout-link-icon']
                                        }),
                                        item.text
                                    ]
                                })
                            }, item._uid))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                "aria-hidden": "true",
                className: classNames(styles.overlay, isExpanded && styles.expanded),
                onClick: ()=>setIsExpanded((prev)=>!prev),
                tabIndex: -1
            })
        ]
    });
};

//# sourceMappingURL=StickyNav.js.map